import styled from 'styled-components';
import { Tabs } from 'antd';

const { TabPane } = Tabs;

const CustomTabsContent = styled(Tabs)(
  () => ` 
  .ant-tabs-nav::before {
    border-bottom: 2px solid #152056;
  }

  .ant-tabs-tab {
    margin-left: 10px;
    margin-right: 10px;
    padding: 18px 24px;
  }

  .ant-tabs-tab .ant-tabs-tab-btn {
    font-size: 16px;
  }

  .ant-tabs-tab-active {
    background-color: #152056;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    

  }

  .ant-tabs-tab-active .ant-tabs-tab-btn {
    color: white;
    font-size: 16px;
  }
  
`,
);

const CustomTabPaneContent = styled(TabPane)(
  () => ` 

`,
);

const CustomTabs = ({ tabs = [], ...props }) => {
  return (
    <CustomTabsContent {...props}>
      {tabs.map((item) => (
        <CustomTabPaneContent tab={item.name} key={item.key}>
          {item.content}
        </CustomTabPaneContent>
      ))}
    </CustomTabsContent>
  );
};

export default CustomTabs;
